import "./App.css";
import { Fragment } from "react";
import { useHistory } from "react-router-dom"
import LoginRouter from "./components/Login/LoginRouter";
import UserRouter from "./components/Users/UserRouter";
import { AuthProvider } from "oidc-react";
import Layout from "./components/Layout/Layout";

function App() {
  const history = useHistory();

  const oidcConfig = {
      onSignIn: () => {
          window.location.hash = "";
          history.replace("/user/create");
      },
      authority: window.location.origin,
      clientId: "EOS",
      scope: "openid profile email login",
      redirectUri: window.location.origin,
      postLogoutRedirectUri: `${window.location.origin}/user`,
      autoSignIn: false,
      automaticSilentRenew: true,
      silentRedirectUri: window.location.origin
  };

  const getQueryVariable = (variable: string): string => {
    const query = window.location.search.substring(1);
    const vars = query.split("&");
    for (let i = 0; i < vars.length; i++) {
      let pair = vars[i].split("=");
      if (decodeURIComponent(pair[0]).toLowerCase() === variable.toLowerCase()) {
        return decodeURIComponent(pair[1]);
      }
    }
    return '';
  };

  const returnUrl = getQueryVariable("returnurl");
  const tokenCode = getQueryVariable("tokencode");
  const email = getQueryVariable("email");
  const logoutId = getQueryVariable("logoutId");
  const tenant = getQueryVariable("tenant");

    if (window.location.pathname.length > 1 && window.location.pathname.match(/.*\/$/)) {
        window.location.href =  window.location.pathname.replace(/\/+$/, window.location.search)
    }

    return (
        <Fragment>
            <AuthProvider {...oidcConfig}>
                <Layout>
                    <LoginRouter returnUrl={returnUrl} tokenCode={tokenCode} email={email} logoutId={logoutId}/>
                    <UserRouter tenant={tenant}/>
                </Layout>
            </AuthProvider>
        </Fragment>
    );
}

export default App;
